module.exports = __webpack_public_path__ + "static/media/plugNegativePlugged.75bd79c6.svg";